import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/project-img6.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

const Projects = () => {

  const projects = [
    {
      title: "Music Player",
      description: "Music Player build with React and TailwindCSS",
      imgUrl: projImg1,
      github: "https://github.com/TiagoGadonski/MusicPlayer",
      demo: "https://playermusic-tiago.netlify.app/",
    },
    {
      title: "Website for Banks",
      description: "Development",
      imgUrl: projImg2,
      github: "https://github.com/TiagoGadonski/bank-site",
      demo: "https://bank-site-tiago.netlify.app/",
    },
    {
      title: "Youtube Clone",
      description: "Video Player with YouTube API",
      imgUrl: projImg3,
      github: "https://github.com/TiagoGadonski/Youtube-Clone",
      demo: "https://ytclonetiago.netlify.app/",
    },
    {
      title: "Website for Dentists",
      description: "Development",
      imgUrl: projImg4,
      github: "https://github.com/TiagoGadonski/doctorcare",
      demo: "https://tiagogadonski.github.io/doctorcare/",
    },
    {
      title: "Tetris Game",
      description: "Development",
      imgUrl: projImg5,
      github: "https://github.com/TiagoGadonski/tetris_js",
      demo: "https://tetrisjsonly.netlify.app",
    },
    {
      title: "Currency Converter",
      description: "Development",
      imgUrl: projImg6,
      github: "https://github.com/TiagoGadonski/currency",
      demo: "https://conversordemoedastgoco.netlify.app",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Recently, I developed some projects with React. The versatility and agility of this framework has allowed me to create high quality applications and exceptional user experiences for my clients.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                    <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}

export default Projects